<template>
    <div>
      <headBox title="公告"></headBox>
      <div class="new_notice">
        <div class="top-box">
          <div class="header-tab">
            <div v-for="(item,i) in listType" :key="i" :class="{'active':curListType==item.id}" 
            @click="listTypeClick(item,i)"
            >{{item.name}}({{item.count>0?item.count:0}}未读)</div>
          </div>
        </div>
        <div class="nav-second-tab" v-if="goodsType.length>0">
          <div class="tab-body">
            <span
              v-for="(item,i) in goodsType"
              :class="{'active':activeGoodsIndex===i}"
              :key="i"
              @click="choseType(item,i)">{{item.subTitle}}({{item.count>0?item.count:0}}未读)</span>
          </div>
        </div>
        <div v-if="list.length>0||loading" v-loading="vLoading">
            <div class="content">
                <div class="item clearfix" v-for="(item,i) in list" @click="gond(item)" :key="i" :class="{'read':item.readStatus==1}">
                    <!-- <span class="left"><i class="isdot" v-if="item.readStatus==0"></i>{{item.title}}</span> -->
                    <span class="left">{{item.title}}</span>
                    <span class="time">{{jqtime(item.createTime)}}</span>
                </div>
            </div>
            <el-pagination
                v-if="list.length!=0"
                class="page"
                background
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange"
                :page-size="pagesize"
                :current-page="currentPage"
                :total="total"
            ></el-pagination>
          </div>
          <div v-else class="no">
              <img src="@static/images/no.png" alt />
              <span>暂无数据</span>
          </div>
        </div>
    </div>
</template>
<script>
//当前实例组件
import headBox from "@/components/head.vue";
export default {
    data: () => ({
        list: [],
        loading:true,
        vLoading:true,
        listType: [
            {id:"",name:"全部公告",count:0},
            {id:"2",name:"商品公告",count:0},
            {id:"3",name:"系统通知",count:0},
        ],
        goodsType: [],
        curGoodsType:"1",
        pagesize: 10,
        currentPage: 1,
        total: 0,
        curListType: "",
        activeGoodsIndex: -1,
    }),
    components: {headBox},
    created() {
        this.getGoodsType();
        this.getAllCount();
    },
    methods: {
        goToBack(){
            window.history.go(-1);
        },
        gond: function(item) {
            item.readStatus = 1;
            var rou = this.$router.resolve("/notice_details/" + item.id);
            window.open(rou.href, "_blank");
            this.getGoodsType();
        },
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getListHttp();
        },
        getListHttp: function() {
            var that = this;
            const params = {
                pageSize: 10,
                pageNum: that.currentPage,
                FirstType: this.curListType,
                SecondType: this.curListType?this.curGoodsType:'',
            }
            if(that.currentPage == 1){
                this.list = []
                this.loading = true;
                this.total = 0;
            }
            this.$http({
                url: '/master/mechanIndex/queryNewMsgList',
                type: 'put',
                params: params
            }).then((data) => {
                this.loading = false;
                this.vLoading = false
                that.total = data.total;
                if (data.data && data.data.length > 0) {
                    that.list = data.data;
                }else{
                    that.list = [];
                }
            });
        },
        jqtime: function(time) {
          if (time) {
            return this.$tools.formatDate(time,"yyyy/MM/dd hh:mm");
          }
        },
        listTypeClick(item, i) {
            this.curListType = item.id;
            this.activeGoodsIndex = 0;
            this.currentPage = 1;
            this.curGoodsType = "1";
            this.getGoodsType();
        },
        choseType(item, i) {
            this.activeGoodsIndex = i;
            this.currentPage = 1;
            this.curGoodsType = this.goodsType[this.activeGoodsIndex].secondType;
            this.getListHttp();
        },
        //获取商品公告筛选条件
        getGoodsType: function() {
            if(!this.curListType){
                this.goodsType = [];
                this.getListHttp();
                return;
            }
            this.$http({
                url:'/master/mechanIndex/queryByFirstType',
                type:'put',
                params: {
                    FirstType: this.curListType
                }
            }).then((res)=> {
                this.vLoading = false
                this.goodsType = res.data;
                this.curGoodsType = this.goodsType[0].secondType;
                this.getListHttp();
            });
        },
        //获取1级分类数量
        getAllCount: function() {
            //this.goodsType=
            this.$http({
                url:'/master/mechanIndex/queryFirstTypeUnRead',
                type:'put',
                params: {}
            }).then((res)=> {
                let sum = 0;
                res.data.forEach(item1=>{
                    if(item1.firstType==2||item1.firstType==3) {
                        sum+=item1.count*1;
                    }
                    this.listType.forEach(item2=>{
                        if(item1.firstType == item2.id) {
                            item2.count = item1.count;
                        }
                    })

                })
                this.listType[0].count = sum;
                // 公告显示未读红点使用
                this.$store.commit("SET_NOTICENUM", sum);
            });
        }
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
@import "~@/sass/pages/new_notice";
</style>
